import { render } from "./BlockPage.vue?vue&type=template&id=80d002c0"
import script from "./BlockPage.vue?vue&type=script&lang=js"
export * from "./BlockPage.vue?vue&type=script&lang=js"

import "./BlockPage.vue?vue&type=style&index=0&id=80d002c0&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__